import type { PhoneNumber } from '../ContactTypes';
import type { ContactItemPropTypes } from './ContactSelectService';

type PhoneNumberWithFormattedValue = PhoneNumber & { formattedNumber: string };
export type AllPhoneNumbersFormatted = {
    isInitializing: boolean;
    allPhoneNumbers: PhoneNumberWithFormattedValue[];
};

export function convertPhoneNumbersToSelectItems(
    phoneNumbers: PhoneNumberWithFormattedValue[],
): ContactItemPropTypes[] {
    return phoneNumbers.map((phoneNumber) => ({
        label: phoneNumber.formattedNumber,
        value: phoneNumber.id,
        isInvalid: phoneNumber.isInvalid,
    }));
}

function getCleanPhoneNumber(number: string): string {
    return number.replace(/[^0-9]/g, '');
}

function arePhoneNumbersSame(firstPhoneNumber: string, secondPhoneNumber: string): boolean {
    return getCleanPhoneNumber(firstPhoneNumber) === getCleanPhoneNumber(secondPhoneNumber);
}

function isPhoneNumberInCDM(phoneNumber: string, phoneNumbers: PhoneNumber[]): boolean {
    return phoneNumbers.some((number) => arePhoneNumbersSame(number.number, phoneNumber));
}

const formatPhoneNumbers = async (
    phoneNumbers: PhoneNumber[],
): Promise<PhoneNumberWithFormattedValue[]> => {
    const { parsePhoneNumberFromString } = await import('libphonenumber-js/max');

    return phoneNumbers.map((phoneNumber) => {
        const parsedNumber = parsePhoneNumberFromString(phoneNumber.number);
        return {
            ...phoneNumber,
            formattedNumber: parsedNumber?.formatInternational() ?? phoneNumber.number,
        };
    });
};

export async function getSelectPhoneNumbers(
    cdmPhoneNumbers: PhoneNumber[],
    selectPhoneNumberValue?: string,
    addValueToItemsIfNotIncluded?: boolean,
): Promise<PhoneNumberWithFormattedValue[]> {
    const phoneNumbers = [...cdmPhoneNumbers];

    if (
        addValueToItemsIfNotIncluded &&
        selectPhoneNumberValue &&
        !isPhoneNumberInCDM(selectPhoneNumberValue, cdmPhoneNumbers)
    ) {
        phoneNumbers.push({
            number: selectPhoneNumberValue,
            id: selectPhoneNumberValue,
        });
    }

    return formatPhoneNumbers(phoneNumbers);
}
